/**
 * Conroo REST Frontend Backend
 * REST Interface for new Conroo backend for frontend app communication.
 *
 * OpenAPI spec version: v1.0.3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

/**
* request body object
*/
export class ConstantForwarderStatisticValueRequestTO {
    /**
    * Forwarder Statistic Name
    */
    'name'?: ConstantForwarderStatisticValueRequestTONameEnum;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "name",
            "baseName": "name",
            "type": "ConstantForwarderStatisticValueRequestTONameEnum",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return ConstantForwarderStatisticValueRequestTO.attributeTypeMap;
    }

    public constructor() {
    }
}


export type ConstantForwarderStatisticValueRequestTONameEnum = "open_orders" | "registered_truckers" ;

